import { Grid, Typography, Button, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import Page from "../../../components/Page";
import TestSeriesCard from "./components/TestSeriesCard";
import SyncLoader from "react-spinners/SyncLoader";
import './test.css';
import { useTheme } from "@emotion/react";
import getAccess from "../../../utils/getAccess";

const Test = () => {
  const access = getAccess();
  const theme = useTheme();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize] = useState(12);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem("token");

    async function fetchUsers() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_LIVE_URL}/adminPanel/getallTestSeriesdetails?page=${page}&pageSize=${pageSize}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();

        if (data.status) {
          const safeData = Array.isArray(data.data) ? data.data : [];

          setUsers(prev =>
            page === 0 ? safeData : [...prev, ...safeData]
          );

          setTotalCount(data.count || 0);
        }
      } catch (error) {
        console.error("Error fetching test series:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchUsers();
  }, [page]);

  return (
    <>
      {loading && page === 0 ? (
        <Stack justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
          <SyncLoader
            color={theme.palette.primary.mainTheme}
            loading={loading}
            size={20}
          />
        </Stack>
      ) : (
        <Page title="Test Series">
          <Typography className="page-heading">
            All Test Series
          </Typography>

          <Grid container pl={5} pr={3} spacing={3}>
            {(access?.access?.includes('32') ||
              access?.accessFortab === 'readWrite' ||
              access?.access?.includes('all')) && (
              <Grid item xs={12} sm={6} md={4}>
                <TestSeriesCard title="notInfo" />
              </Grid>
            )}

            {users.map((item, i) => (
              <Grid item key={item.id || i} xs={12} sm={6} md={4}>
                <TestSeriesCard title="Info" data={item} />
              </Grid>
            ))}
          </Grid>

          {/* Load More Button */}
          {users.length < totalCount && (
            <Stack alignItems="center" mt={4}>
              <Button
                variant="contained"
                onClick={() => setPage(prev => prev + 1)}
              >
                Load More
              </Button>
            </Stack>
          )}
        </Page>
      )}
    </>
  );
};

export default Test;